import { openNotificationWithIcon } from '../../../../../utils/notification.helper'
import React from 'react'
import { useCreateConceptualLabelMutation } from '../../../../../store/apis/conceptual-label.api'
import { useFetchConceptualLabelTypesQuery } from '../../../../../store/apis/conceptual-label-type.api'
import ConceptualLabelForm, { FORM_FIELDS } from '../ConceptualLabelForm'
import { useSelector } from 'react-redux'
import conceptualLabelSelectors from '../../../../../store/selectors/conceptual-label.selectors'

const CreateConceptualLabelForm = ({ onSuccess }) => {
    const [createConceptualLabel, createConceptualLabelResult] = useCreateConceptualLabelMutation()
    const baseInitialValues = useSelector(conceptualLabelSelectors.createFormInitialValues)
    const { data: conceptualLabelTypes } = useFetchConceptualLabelTypesQuery()

    // Check if there's only one type available and auto-set it
    const hasSingleType = conceptualLabelTypes && conceptualLabelTypes.length === 1
    const singleTypeId = hasSingleType ? conceptualLabelTypes[0].id : null

    // Merge initial values with auto-selected type if applicable
    const initialValues = {
        ...baseInitialValues,
        ...(hasSingleType && !baseInitialValues?.typeId && { typeId: singleTypeId }),
    }

    const onSubmit = async values => {
        const response = await createConceptualLabel({
            name: values.name,
            description: values.description,
            disciplineId: values.disciplineId,
            source: values.source,
            parentId: values.parentId,
            typeId: values.typeId,
        })

        if ('data' in response) {
            openNotificationWithIcon('success', 'Conceptual label created successfully')
            onSuccess()
        }
    }

    return (
        <ConceptualLabelForm
            onSubmit={onSubmit}
            error={createConceptualLabelResult?.error}
            loading={createConceptualLabelResult?.isLoading}
            actionName='Create'
            initialValues={initialValues}
            readonlyFields={(() => {
                const fields = []
                if (initialValues?.parentId || initialValues?.disciplineId) {
                    fields.push(FORM_FIELDS.DISCIPLINE, FORM_FIELDS.PARENT)
                } // Make type readonly if only one type is available

                if (hasSingleType) {
                    fields.push(FORM_FIELDS.TYPE)
                }
                return fields
            })()}
        />
    )
}

export default CreateConceptualLabelForm
